var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.integrationDetails
      ? _c(
          "div",
          { staticClass: "my-4" },
          [
            _c("validated-input", {
              attrs: { label: "PB Customer Number" },
              model: {
                value:
                  _vm.integrationDetails.results[0].response.customerNumber,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.integrationDetails.results[0].response,
                    "customerNumber",
                    $$v
                  )
                },
                expression:
                  "integrationDetails.results[0].response.customerNumber",
              },
            }),
            _c("validated-input", {
              attrs: { label: "PB warehouse prefix" },
              model: {
                value: _vm.integrationDetails.results[0].reqBody.profillPrefix,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.integrationDetails.results[0].reqBody,
                    "profillPrefix",
                    $$v
                  )
                },
                expression:
                  "integrationDetails.results[0].reqBody.profillPrefix",
              },
            }),
            _c("validated-input", {
              attrs: { label: "P3 Customer Number" },
              model: {
                value:
                  _vm.integrationDetails.results[1].response.customerNumber,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.integrationDetails.results[1].response,
                    "customerNumber",
                    $$v
                  )
                },
                expression:
                  "integrationDetails.results[1].response.customerNumber",
              },
            }),
            _c("validated-input", {
              attrs: { label: "P3 warehouse prefix" },
              model: {
                value: _vm.integrationDetails.results[1].reqBody.profillPrefix,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.integrationDetails.results[1].reqBody,
                    "profillPrefix",
                    $$v
                  )
                },
                expression:
                  "integrationDetails.results[1].reqBody.profillPrefix",
              },
            }),
            _c("validated-input", {
              attrs: { label: "P7 Customer Number" },
              model: {
                value:
                  _vm.integrationDetails.results[2].response.customerNumber,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.integrationDetails.results[2].response,
                    "customerNumber",
                    $$v
                  )
                },
                expression:
                  "integrationDetails.results[2].response.customerNumber",
              },
            }),
            _c("validated-input", {
              attrs: { label: "P7 warehouse prefix" },
              model: {
                value: _vm.integrationDetails.results[2].reqBody.profillPrefix,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.integrationDetails.results[2].reqBody,
                    "profillPrefix",
                    $$v
                  )
                },
                expression:
                  "integrationDetails.results[2].reqBody.profillPrefix",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }